import { useUniversalEntityPageContext } from "../../../contexts/UniversalEntityPageContext";
import { useFilterContext } from "@/contexts/FilterContext";
import type { BaseEntity } from "../../../../UniversalCRMTable/types";

export const useContexts = <T extends BaseEntity>() => {
  // Get context for saved views state
  let context;
  try {
    context = useUniversalEntityPageContext<T>();
  } catch {
    context = null;
  }

  // Get FilterContext for applying saved views
  let filterContext;
  try {
    filterContext = useFilterContext<T>();
  } catch {
    filterContext = null;
  }

  return { context, filterContext };
};
